import { useState } from "react";
const LanguageManager = ({languages, setLanguages}) => {
  const [teachingLanguages, setTeachingLanguages] = useState("");

  const handleAddLanguage = () => {
    const trimmedLang = teachingLanguages.trim();
    if (trimmedLang && !languages.includes(trimmedLang)) {
      setLanguages([...languages, trimmedLang]);
      setTeachingLanguages(""); // Clear input
    }
  };

  const handleDeleteLanguage = (langToDelete) => {
    setLanguages(languages.filter((lang) => lang !== langToDelete));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleAddLanguage();
    }
  };

  return (
   <div className="mx-auto p-6 max-w-[900px] flex flex-col gap-6">

  {/* Header */}
  <div className="flex items-center gap-3">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
      </svg>
    </div>
    <h4 className="text-lg font-semibold text-gray-900">Teaching Languages</h4>
  </div>

  {/* Input Group */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Add Language</label>
    </div>
    <div className="flex gap-3 flex-col sm:flex-row">
      <input
        type="text"
        value={teachingLanguages}
        onChange={(e) => setTeachingLanguages(e.target.value)}
        placeholder="Enter a language"
        onKeyPress={handleKeyPress}
        className="flex-1 px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
      <button
        onClick={handleAddLanguage}
        className="px-6 py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors w-full sm:w-auto whitespace-nowrap"
      >
        Add Language
      </button>
    </div>
    <p className="text-xs text-gray-500 mt-2">Press Enter to add multiple languages</p>
  </div>

  {/* Languages List */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Added Languages</label>
    </div>
    
    {languages.length > 0 ? (
      <ul className="flex flex-col gap-2">
        {languages.map((lang, index) => (
          <li
            key={index}
            className="flex justify-between items-center bg-white p-4 border border-gray-200 rounded-xl hover:border-[#0f6abf] transition-all"
          >
            <span className="text-sm font-medium text-gray-900">{lang}</span>
            <button
              onClick={() => handleDeleteLanguage(lang)}
              className="px-3 py-1.5 bg-red-50 text-red-600 border border-red-200 rounded-lg text-xs font-medium hover:bg-red-600 hover:text-white transition-colors"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    ) : (
      <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-700 mb-2">No languages added yet</h3>
        <p className="text-sm text-gray-500">Add your first teaching language above</p>
      </div>
    )}
  </div>
</div>

  );
};

export default LanguageManager;